import { TestRunService } from '@/api/testRun';
import { HideCustomCreateButton } from '@/components/shared/button/HideCustomButtonCreate';
import { OutlineButton } from '@/components/shared/button/OutlineButton';
import { IFilterSpec } from '@/components/shared/filter/TableFilterPanel';
import { ExtendedTableLowCode } from '@/components/shared/table/ExtendedTableLowCode';
import { useBackNavigate } from '@/utils/hooks/useBackNavigate';
import { useCustomSpec } from '@/utils/hooks/useCustomSpec';
import { Button, Dialog, ModalRef } from 'alurkerja-ui';
import React, { useRef, useState } from 'react';
import { useParams } from 'react-router-dom';

export const ListArchiveTestRun: React.FC = () => {
  const { id } = useParams();
  const backNavigate = useBackNavigate();
  const ref = useRef<ModalRef>(null);

  const spec = useCustomSpec('/api/crud/test-run', {
    columns: [{ key: 'title', label: 'Title' }],
  });

  const filterSpec: IFilterSpec[] = [
    { name: 'title', label: 'Title', type: 'text' },
  ];

  const [selectedRow, setSelectedRow] = useState<string[]>([]);
  const { mutate: archiveMutate, isPending: isArchiveLoading } =
    TestRunService.useUnarchive();

  const unarchiveAction = (idList: string[]) => {
    idList.forEach(id => {
      archiveMutate(id, {
        onSuccess: () => {
          Dialog.success({
            title: 'Success',
            description: 'Test run has been unarchived',
            callback: () => {
              ref.current?.closeModal();
              backNavigate();
            },
          });
        },
        onError: () => {
          Dialog.error({
            title: 'Error',
            description: 'Failed to unarchive test run',
          });
        },
      });
    });
  };

  return (
    <div className="tab-group">
      <div className="justify-between tab-list">
        <OutlineButton onClick={backNavigate}>Back</OutlineButton>

        <Button
          onClick={() => unarchiveAction(selectedRow)}
          loading={isArchiveLoading}
          disabled={selectedRow.length === 0}
        >
          Revert Back
        </Button>
      </div>

      <div className="mx-4">
        <ExtendedTableLowCode
          spec={spec}
          defaultFilter={{ project_id: id, is_archive: true }}
          hideActionColumn
          customButtonCreate={HideCustomCreateButton}
          showCheckbox
          selectedRow={selectedRow}
          setSelectedRow={setSelectedRow}
          showFilter
          filterSpec={filterSpec}
        />
      </div>
    </div>
  );
};
